/* eslint formatjs/no-literal-string-in-jsx: "error" */
import React from "react"
import { useStateMachine } from "../../../context/stateMachine/StateMachineV2"
import { useMedicalInfo } from "../../context/MedicalInfoContext"
import { StepLayout } from "components/carrot-plans/shared/StepLayout"
import { ButtonFooterLayout, ContinueButton } from "components/carrot-plans/shared/ButtonFooter"
import { FormattedMessage, useIntl } from "react-intl"
import { Box } from "@carrotfertility/carotene-core"
import { Form } from "@carrotfertility/carotene-core-x"
import { RoutingFlowTitle } from "components/carrot-plans/shared"
import { useParams } from "react-router-dom"
import useCarrotPlan from "../../hooks/useCarrotPlan"
import { CarrotPlanStep } from "../../../../types/carrotPlanTypes"

export default function WelcomeStep(): JSX.Element {
  const intl = useIntl()
  const { data: currentCarrotPlan, isLoading: isCarrotPlanLoading } = useCarrotPlan()
  const { medicalInfo, startMedicalInfo } = useMedicalInfo()
  const { journey } = useParams<{ journey: string }>()

  const medicalInfoStartedFromMenuItem = journey != null
  const medicalInfoInProgress = currentCarrotPlan?.steps.some(
    (step: CarrotPlanStep) => step.carrotPlanStepId === medicalInfo?.medicalCarrotPlanStepId
  )

  const skipWelcomeScreenIfMedicalInfoInProgress = () => {
    const skip = ""
    const doNotSkip = null
    if (!isCarrotPlanLoading) {
      if (medicalInfoStartedFromMenuItem) {
        return medicalInfoInProgress ? skip : doNotSkip
      }
      return medicalInfo ? skip : doNotSkip
    }
  }

  const { send } = useStateMachine(skipWelcomeScreenIfMedicalInfoInProgress())

  async function onClickContinue(): Promise<void> {
    if (medicalInfoStartedFromMenuItem && !medicalInfoInProgress) {
      await startMedicalInfo({ fromMedicalMenuItem: true })
    }
    send("")
  }

  const header = intl.formatMessage({
    defaultMessage: "We have some optional health questions for the person seeking or receiving care."
  })

  return (
    <>
      <RoutingFlowTitle title={header} />
      <Box display="flex" justifyContent="center" marginBottom={(theme) => theme.spacing(theme.tokens.spacing.lg)}>
        <Box
          component="img"
          src={`/images/illo-yir-telehealth.png`}
          srcSet={`/images/illo-yir-telehealth-2x.png`}
          alt=""
          marginBottom={(theme) => theme.spacing(theme.tokens.spacing.md)}
          width={228}
          height={228}
        />
      </Box>
      <StepLayout
        header={header}
        formElements={
          <Form onSubmit={onClickContinue}>
            <ButtonFooterLayout
              continueButton={
                <ContinueButton>
                  <FormattedMessage defaultMessage="Continue" />
                </ContinueButton>
              }
            />
          </Form>
        }
      />
    </>
  )
}
